<template>

  <div class="container"
    style="width: 100%;margin: 0px;padding: 0px;max-width: 100%;min-height: max-content;z-index: 0;height: auto;overflow-y:hidden">
    <div class="row gx-0 gy-0 justify-content-center align-items-center"
      style="background: transparent;overflow-x: clip;min-height: 90vh;">
      <div class="col d-grid justify-content-xl-center align-items-xl-center zstack custom-col order-sm-1"
        style="background: transparent;overflow-x: visible;grid-column: 1;grid-row: 1;overflow-y: visible;/*place-items: end end;*//*grid-template-columns: 1fr;*//*grid-template-rows: 1fr;*//*overflow-y: hidden;*/padding-right: 1rem;padding-left: 1rem;">
        <div style="width: 100%;height: 100%;overflow-x: visible;place-self: center center;opacity: 1;">
          <div class="blurryCircle"
            style="background: rgb(255,107,23);width: 50vw;height: 50vw;min-height: 10rem;min-width: 10rem;place-self: end end;border-radius: 9999px;position: relative;/*left: 50%;*/top: 50%;z-index: -1;transform: translate3d(0, 0, 0);">
          </div>
        </div>
        <div
          class="text-center d-flex d-xl-flex flex-column justify-content-center align-items-center justify-content-xl-center align-items-xl-center zstack materialBackground"
          style="width: auto;border-radius: 15px;box-shadow: 0px 0px 19px rgba(0,0,0,0.24);aspect-ratio: 1/1;height: auto;overflow: clip;padding: 2rem;max-height: 30rem;">
          <h1 class="text-center" style="justify-self: start;margin-bottom: auto; padding-bottom: 1rem;">Sign Up To Our Resource Hub</h1>
          <form @submit.prevent="signup" class="d-flex d-xl-flex flex-column px-5 justify-content-xl-center align-items-xl-center gap-2"
            style="width: 100%;height: 100%;">
            <input class="form-control" v-model="name" type="text" name="Full Name" placeholder="Full Name" autofocus="" required="" style="margin-top: auto;">
            <input class="form-control" v-model="email" type="email" name="Email" placeholder="Email" inputmode="email" required="">
            <input class="form-control" v-model="password" type="password" placeholder="Password" name="Password" required="">
            <div v-if="passwordErrors.length" class="text-danger">
              <ul>
                <li v-for="error in passwordErrors" :key="error">{{ error }}</li>
              </ul>
            </div>
            <input class="form-control" v-model="confirmPassword" type="password" placeholder="Confirm Password" name="Confirm Password" required="">
            <div v-if="confirmPasswordError" class="text-danger">{{ confirmPasswordError }}</div>
            <div class="d-flex gap-2 align-items-center">
                <input id="mailList" v-model="subscribeToMailList" type="checkbox" name="Recieve the latest news about AIBoosted's projects and announcements">
                <label for="mailList" style="font-size: 0.8rem;">Recieve the latest news about AIBoosted's projects and announcements</label>
            </div>
            <button :disabled="signingUp" class="btn btn-primary" type="submit" style="margin-top: auto;">Sign Up</button>
            <NuxtLink to="/resources/login" type="submit" style="">Already have an account?</NuxtLink>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
input[type='checkbox'] {
    width:30px;
    height:30px;
}
</style>
<script setup>
import { doc, setDoc } from 'firebase/firestore';
import { createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from 'firebase/auth';

useHead({
    title: "Resource Hub - Sign Up | AIBoosted"
})

const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const name = ref("")
const subscribeToMailList = ref(false)

const pressedSubmitOnce = ref(false)

const auth = useFirebaseAuth();
const user = useCurrentUser();

const firestore = useFirestore();

const passwordErrors = computed(() => {
  if (!pressedSubmitOnce.value) return [];
  const errors = [];
  if (password.value.length < 8) errors.push("Password must be at least 8 characters long.");
  if (!/[A-Z]/.test(password.value)) errors.push("Password must contain at least one uppercase letter.");
  if (!/[a-z]/.test(password.value)) errors.push("Password must contain at least one lowercase letter.");
  if (!/[0-9]/.test(password.value)) errors.push("Password must contain at least one number.");
  if (!/[^A-Za-z0-9]/.test(password.value)) errors.push("Password must contain at least one special character.");
  return errors;
});

const confirmPasswordError = computed(() => {
  return password.value !== confirmPassword.value ? "Passwords do not match." : "";
});

const signingUp = ref(false)
const route = useRoute()

const signup = async () => {
  signingUp.value = true;
  pressedSubmitOnce.value = true;

  if (passwordErrors.value.length > 0 || confirmPasswordError.value || !email.value || !name.value) {
    signingUp.value = false;
    return;
  }


  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email.value, password.value);
    await updateProfile(userCredential.user, {
      displayName: name.value
    })
    // Send email verification
    const redirectUrl = window.location.origin + "/resources/login?verified=true"
    await sendEmailVerification(userCredential.user, {
      url: redirectUrl
    })

    // Create user document in Firestore
    const userDocRef = doc(firestore, `Users/${userCredential.user.uid}`);
    await setDoc(userDocRef, {
      email: email.value,
      createdAt: new Date(),
      name: name.value,
      subscribeToMailList: subscribeToMailList.value
    });

    // Redirect to another page after successful login
    if (route.query.redirectedFrom) {
      await navigateTo({
        path: "/resources/login",
        query: {
          unverified: true,
          redirectedFrom: route.query.redirectedFrom
        }
      })
    } else {
      await navigateTo({
        path: "/resources/login",
        query: {
          unverified: true
        }
      })
    }

  } catch (error) {
    alert("Error signing up: " + error.message);
  } finally {
    signingUp.value = false;
  }
};

onMounted(() => {
  watch(user, (currentUser, previousUser) => {
    // redirect to login if they logout and the current
    // route is only for authenticated users
    if (
      !currentUser &&
      previousUser &&
      route.meta.middleware?.includes("auth")
    ) {
      console.log("User signed out, going back to login")
      return navigateTo("/resources/signup")
    }
    // redirect the user if they are logged in but were
    // rejected because the user wasn't ready yet, logged in
    // then got back to this page
    if (currentUser && typeof route.query.redirectedFrom === 'string') {
      console.log("redirecting back to " + route.query.redirectedFrom)
      return navigateTo(route.query.redirectedFrom)
    }
  })
})

</script>

<style scoped>
.text-danger {
  color: red;
}
</style>
